import type { OwnerRezWidget } from '../types';
import { useOwnerRezWidgetLoader } from '@/hooks/useOwnerRezWidgetLoader';
import OwnerRezEmbed from './OwnerRezEmbed';

type Props = {
  propertyName: string;
  widgets: OwnerRezWidget[];
};

export default function OwnerRezWidgets({ propertyName, widgets }: Props) {
  const availability = widgets.find((widget) => widget.kind === 'availability');
  const booking = widgets.find((widget) => widget.kind === 'booking');

  useOwnerRezWidgetLoader(propertyName, widgets);

  if (!availability && !booking) return null;

  return (
    <section id="booking" className="bg-background-50 py-20 md:py-28 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 2xl:gap-14 items-start">
          <div className="lg:col-span-3">
            <h2 className="font-heading text-foreground-950 text-4xl md:text-5xl leading-[1.07] tracking-[-0.01em]">
              Check dates{' '}
              <span className="block italic font-light text-foreground-600">and request your stay.</span>
            </h2>
            <p className="mt-6 text-foreground-600 text-base font-light leading-relaxed max-w-md">
              Check dates, pricing, and booking details for {propertyName} below.
            </p>
          </div>

          <div className="lg:col-span-9 grid min-w-0 grid-cols-1 xl:grid-cols-[minmax(0,1.25fr)_minmax(360px,0.75fr)] gap-6 items-start">
            {availability && (
              <div className="ownerrez-widget-shell min-w-0 rounded-2xl bg-background-100/60 border border-background-200/80 p-0 sm:p-4 md:p-6">
                <OwnerRezEmbed widget={availability} />
              </div>
            )}

            {booking && (
              <div className="ownerrez-widget-shell min-w-0 rounded-2xl bg-background-100/60 border border-background-200/80 p-0 sm:p-4 md:p-6">
                <OwnerRezEmbed widget={booking} />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
